import { render } from "./AboutView.vue?vue&type=template&id=af040b76&scoped=true"
const script = {}

import "./AboutView.vue?vue&type=style&index=0&id=af040b76&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af040b76"]])

export default __exports__